export const ActivitiesTab = {
  ACTIVITIES: 'activities',
  PAST_ACTIVITIES: 'pastActivities',
};
